import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { NavLink } from "react-router-dom";
import logo from "../img/AI Logo Black@2x.png";
import "../styles/NavStyles.css";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../translations/translations";

const NavBar: React.FC = () => {
    const { language, toggleLanguage } = useLanguage();
    const t = translations[language];

    return (
        <AppBar
            position="fixed"
            elevation={0}
            sx={{
                top: 10,                                
                left: "50%",
                transform: "translateX(-50%)",         
                width: "calc(100% - 32px)",            
                borderRadius: 4,
                backdropFilter: "blur(12px)",
                backgroundColor: "rgba(255, 255, 255, 0.25)",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
                px: 2,
                py: 1,                                 
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                }}
            >
                {/* LEFT: Logo */}
                <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
                    <Box
                        component="img"
                        src={logo}
                        alt="Logo"
                        sx={{
                            height: 40,
                            width: "auto",
                            borderRadius: 1,
                        }}
                    />
                </Box>

                {/* CENTER: Navigation Links */}
                <Box
                    sx={{
                        flexGrow: 1,
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                    }}
                >
                    <NavLink
                        to="/"
                        className={({ isActive }) =>
                            `nav-link ${isActive ? "nav-link-active" : ""}`
                        }
                    >
                        {t.nav.home}
                    </NavLink>

                    <NavLink
                        to="/quiz"
                        className={({ isActive }) =>
                            `nav-link ${isActive ? "nav-link-active" : ""}`
                        }
                    >
                        {t.nav.quiz}
                    </NavLink>

                    <NavLink
                        to="/sources"
                        className={({ isActive }) =>
                            `nav-link ${isActive ? "nav-link-active" : ""}`
                        }
                    >
                        {t.nav.sources}
                    </NavLink>
                </Box>

                {/* RIGHT: Language Switcher */}
                <IconButton color="inherit" onClick={toggleLanguage}>
                    <span style={{ fontSize: 26 }}>
                        {language === "de" ? "🇩🇪" : "🇺🇸"}
                    </span>
                </IconButton>
            </Box>
        </AppBar>
    );
};

export default NavBar;
